import React, { SVGProps } from 'react'

const OtherDocumentIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_4270_13014"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4270_13014)">
        <path d="M3.5 16.5V2H11L14 5V16.5H3.5Z" fill="#F5F5F5" />
        <path
          d="M3.89736 15.1111C3.54663 15.1111 3.25381 14.9893 3.01888 14.7457C2.78396 14.5021 2.6665 14.1984 2.6665 13.8347V2.16533C2.6665 1.80161 2.78396 1.49794 3.01888 1.25432C3.25381 1.0107 3.54663 0.888885 3.89736 0.888885H9.9046L13.3332 4.44444V13.8347C13.3332 14.1984 13.2157 14.5021 12.9808 14.7457C12.7459 14.9893 12.453 15.1111 12.1023 15.1111H3.89736ZM9.52365 4.8395V1.67901H3.89736C3.78003 1.67901 3.67254 1.72964 3.57488 1.83091C3.47723 1.93218 3.42841 2.04365 3.42841 2.16533V13.8347C3.42841 13.9563 3.47723 14.0678 3.57488 14.1691C3.67254 14.2704 3.78003 14.321 3.89736 14.321H12.1023C12.2196 14.321 12.3271 14.2704 12.4248 14.1691C12.5224 14.0678 12.5713 13.9563 12.5713 13.8347V4.8395H9.52365Z"
          fill="#5E5E5E"
        />
      </g>
    </svg>
  )
}

export default OtherDocumentIcon
